import React, { useState, useEffect } from 'react'
import { BackArrowFeed, CalendarChallengeIcon, ExitChallenge, InfoIconBranding, LocationChallengeIcon, RecognitionWarningIcon, RewardsChallengeIcon } from '../../utils/icons'
import PropTypes from 'prop-types';
import { TabViewNew } from '../ChallengeDetailsV2/styles';
import {  BottomContainer, ChallengeDetailsConatainer, ChallengeHeading, ChallengesContainer, ColorBox, DateLocationContainer, ImageLayout, LevelConatiner, MonthlyCalendar, ProgressCard, RightContainer } from './styles';
import { Border } from '../RecogntionAdmin/styles';
import { CalendarPicker, CalendarWrapper } from '../LogWorkoutCategoryV3/styles';
import Calendar from 'react-calendar';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import HoverButton from '../common/HoverButtonV2';
import CommonModalNew from '../common/CommonModal/CommonModalNew';
import { commaSeperator, convertDateInTimezone, convertMonthFromDate, fetchApi } from '../../utils/methods';
import { toast } from 'react-toastify';
import { ExitMonthlyGoalChallenge, GetMonthlyGoalChallengeDetails } from '../../redux/constants/apiConstants';
import { useParams } from 'react-router-dom';
import { ImageUrl } from '../../utils/constants';
import moment from 'moment';
import DailyProgressGraph from './DailyProgressGraph';
import { useLocation } from "react-router-dom";
import SkeletonLoder from '../common/skeletonLoder';


function MonthlyChallengeDetailsPage({ history }) {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState("Challenge");
  const [selectedDate, setSelectedDate] = useState(null);
  const [exitChallengePopup, setExitChallengePopup] = useState(false);
  const [challengeDetails, setChallengeDetails] = useState(null);
  const ActivityType =challengeDetails?.challenge_participants?.challenge_level?.activity_type
  const [isExiting, setIsExiting] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const isCompletedTab = location?.state?.completedTab;


  useEffect(() => {
    if (id) {
      FetchChallenegesData(id);
    }
  }, [id])


  const FetchChallenegesData = async(challengeId)=>{
    setIsLoading(true);   
    try {
      const res = await fetchApi(GetMonthlyGoalChallengeDetails + "/" + challengeId, "GET");
      if(res.status === 'success'){
        setChallengeDetails(res.data);
        if (res.data?.start_date && isCompletedTab) {
          const firstDay = moment(res.data.start_date).toDate();
          setSelectedDate(firstDay);
        }
        else{
          const today = new Date();
          setSelectedDate(today);
        }
       
      }else{
        toast.error((res?.data?.message))
      }
    } catch (error) {
      window.console.error(error);
    }
    finally {
      setIsLoading(false);   // ✅ stop loading
    }
  }


  const joinChallenge = async() => {
    if (isExiting) return; 
    setIsExiting(true);
    const payload = {
      monthly_gaol_challenge_id: id,
    };

    try {
      const res = await fetchApi(ExitMonthlyGoalChallenge, "POST", payload);
      if (res.status === "success") {
        toast.success(res?.data?.message);
        history.push("/portal")
      } else {
        toast.error(res?.data?.message);
        setIsExiting(false);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
      setIsExiting(false);
    } 
    
    setExitChallengePopup(false);
  };


  const popover = () => (
    <Popover
      id="points-popover"
      className="custom-popover"
    >
      <Popover.Body>
      Thanks for joining. You’ll receive your points <br />
      at the end of the challenge.
      </Popover.Body>
    </Popover>
  );


  const exitChallenge = () => {
    setExitChallengePopup(true);
  }

  const hideExitChallenge = () => {
    setExitChallengePopup(false);
  }


  const getSelectedDateData = () => {
    if (!challengeDetails?.calendar || !selectedDate) return null;
  
    return challengeDetails.calendar.find((item) =>
      moment(item.date).isSame(moment(selectedDate), "day")
    );
  };


  const totalActivity =
  challengeDetails?.challenge_participants?.challenge_level?.total_activity;

  const monthlyTarget =
    challengeDetails?.challenge_participants?.challenge_level?.monthly_target_steps;
  
  const progressPercentage =
  totalActivity && monthlyTarget
    ? Math.min(Math.round((totalActivity / monthlyTarget) * 100), 100)
    : 0;

   
  // const rewardPointsPerUnit =
  //   challengeDetails?.reward_points_per_unit; // e.g. 1
  
  // const pointsPerActivityUnit =
  //   challengeDetails?.points_per_activity_unit; // e.g. 1000


  // const earnedPoints =
  // totalActivity && rewardPointsPerUnit && pointsPerActivityUnit
  //   ? Math.floor(
  //     (totalActivity / pointsPerActivityUnit) * rewardPointsPerUnit
  //   )
  //   : 0;



  window.console.log("monthlyTarget",progressPercentage)

  const renderLeftContainer = () => (
    <div className="leftContainer">
      <ImageLayout>
        <img  src={ImageUrl + "/" + challengeDetails?.image}  alt="Challenge banner"/>
      </ImageLayout>
      <Border margin={"20px 0 "} background={'#EFEFEF'} height={'0.75px'} />
      <div className="AboutHeading">About the challenge</div>
      <div className="des">
        {challengeDetails?.descriptions}
      </div>
      <Border margin={"20px 0 "} background={'#EFEFEF'} height={'0.75px'} />
      <DateLocationContainer>
        <div className="insideBox">
          {CalendarChallengeIcon()}
          <div className="text">
            {convertMonthFromDate(
              moment(convertDateInTimezone(challengeDetails?.start_date)).format("MMMM D")
            )} - {convertMonthFromDate(
              moment(convertDateInTimezone(challengeDetails?.end_date)).format("MMMM D, YYYY")
            )}
          </div>
        </div>
        <div className="insideBox">
          {LocationChallengeIcon()}
          <div className="text">{challengeDetails?.location}</div>
        </div>
      </DateLocationContainer>

      {isCompletedTab ? (
        challengeDetails?.challenge_participants?.challenge_level?.reward_xp ? (
          <div className="rewardBox">
            {RewardsChallengeIcon()}
            <div className="rewardHeading">
              You Earned +{challengeDetails?.challenge_participants?.challenge_level?.reward_xp} XP
            </div>
          </div>
        ) : null
      ) : (
        <div className="rewardBox">
          {RewardsChallengeIcon()}
          <div className="rewardValue">
            {challengeDetails?.reward_points_per_unit} XP per{" "}
            {challengeDetails?.points_per_activity_unit} {ActivityType}
          </div>
        </div>
      )}
      {/* <Border margin={"20px 0 "} background={'#EFEFEF'} height={'0.75px'} /> */}
      {/* <BottomContainer>
        <div className="row">
          <div className="boldTexBox">Total Perfect Days - {challengeDetails?.perfect_days}</div>
          <div className="boldTexBox">Total Longest Streak - {challengeDetails?.longest_streak}</div>
        </div>
        <div className="secondRow seconRowMargin">
          <div className="rowContennt">
            <ColorBox />
            <div className="textBox">Completed</div>
          </div>
          <div className="rowContennt">
            <ColorBox isColor="#F6D5D6" />
            <div className="textBox">Not Completed</div>
          </div>
        </div>
        <div className="secondRow">
          <div className="rowContennt">
            <ColorBox isColor="#D3DEF2" />
            <div className="textBox">Today’s Date</div>
          </div>
          <div className="rowContennt">
            <ColorBox isColor="#DCDCDC" />
            <div className="textBox">N/A</div>
          </div>
        </div>
      </BottomContainer> */}

    </div>
  );

  const selectedDayData = getSelectedDateData();
  const selectedDayTotal = selectedDayData?.total || 0;
  const formattedActivityType =
  ActivityType?.charAt(0).toUpperCase() + ActivityType?.slice(1);


  const renderRightContainer = () => (
    <div>
      <RightContainer>
        <LevelConatiner>
          <img className="levelImage" src={ImageUrl + "/" + challengeDetails?.challenge_participants?.challenge_level?.icon}></img>
          <div className="levelName">{challengeDetails?.challenge_participants?.challenge_level?.level_name}</div>
        </LevelConatiner>
        <div className="statsRow">
          <div className="statBox">
            <div className="label">Daily Average</div>
            <div className="value">{commaSeperator(challengeDetails?.average_daily_goal)} <span className="stepText">{ActivityType}</span></div>
          </div>
          <div className="statBox">
            <div className="label">Daily Goal</div>
            <div className="value">{commaSeperator(challengeDetails?.challenge_participants?.challenge_level?.daily_goal_steps)} <span className="stepText">{ActivityType}</span></div>
          </div>
        </div>
        <LevelConatiner style={{ position: "relative" }} isPadding={"8px 16px 0px 16px"}>
          <div className="dateContainer">
            {moment(selectedDate).format("MMM DD, YYYY")}</div>
          <div className="graphContainer">
            <div className="graphContent">
              <DailyProgressGraph
                selectedDate={selectedDate}
                // value={getSelectedDateData()?.total || 0}
                value={selectedDayTotal}
                max={challengeDetails?.challenge_participants?.challenge_level?.daily_goal_steps}
                icon={CalendarChallengeIcon()} // replace with your SVG
                challengeDetails={challengeDetails}
                ActivityType={ActivityType}
              />
            </div>
            <div style={{ marginLeft: "12px" }}>
              <div className="stepsDetails">
                {commaSeperator(selectedDayTotal)} 
              </div>
              <div style={{ fontSize: "16px", color: "#184A61" }}>
                / {commaSeperator(challengeDetails?.challenge_participants?.challenge_level?.daily_goal_steps)} {formattedActivityType}
              </div>
            </div>
          </div>
        </LevelConatiner>
        <LevelConatiner style={{ display: "block" }}>
          <CalendarView />
          <BottomContainer>
            <div className="secondRow seconRowMargin">
              <div className="rowContennt">
                <ColorBox />
                <div className="textBox">Completed</div>
              </div>
              <div className="rowContennt">
                <ColorBox isColor="#F6D5D6" />
                <div className="textBox">Not Completed</div>
              </div>
            </div>
          </BottomContainer>

        </LevelConatiner>
        <ProgressCard  isWidth={progressPercentage}  isColor={ActivityType == "steps" ? "#DA6C74" : ActivityType == "miles" ? "#DA9B6C" : "#75B084" } >
          <div className="progressCard">
            <div className="progressText">Progress - <span className="value">&nbsp;{commaSeperator(totalActivity)} {ActivityType}</span></div>
            <div className="progressText">Goal -  <span className="value">&nbsp;{commaSeperator(monthlyTarget)} {ActivityType}</span></div>
          </div>
          <div className="ProgressBar">
            <div className="insideBar"></div>
          </div>
        </ProgressCard>
        <div className="pointeSection">
          <div className="heading">{isCompletedTab ? "Total Points Earned - " : "Points earned so far - "} <span className="pointValue">{challengeDetails?.points_earned_so_far}XP</span></div>
          <OverlayTrigger placement="bottom" overlay={popover()}  containerPadding={10}
            popperConfig={{ strategy: 'fixed' }}>
            <div className="icon">{InfoIconBranding()}</div>
          </OverlayTrigger>
        </div>
      </RightContainer>
    </div>

  );
  


  const CalendarView = () => {
    const isFutureDate = (date) => {
      window.console.log("date")
      return moment(date).isAfter(moment(), "day");
    };
       
    const isSameDay = (date1, date2) => {
      window.console.log("date")
      return moment(date1).isSame(moment(date2), "day");
    };
       
    const getCalendarStatus = (date) => {
      window.console.log("date")
      return challengeDetails?.calendar?.find((item) =>
        moment(item.date).isSame(moment(date), "day")
      );
    };

    const startOfMonth = isCompletedTab ? moment(challengeDetails?.start_date).toDate() : moment().startOf("month").toDate();
    const endOfMonth = isCompletedTab ? moment(challengeDetails?.end_date).toDate() : moment().endOf("month").toDate();


    return(
      <CalendarWrapper>
        <CalendarPicker>
          <MonthlyCalendar>
            <Calendar
              value={selectedDate}
              onChange={setSelectedDate}
              prevLabel={null}
              minDate={startOfMonth}           
              maxDate={endOfMonth}   
              nextLabel={null}
              prev2Label={null}
              navigationLabel={null} 
              next2Label={null}
              formatShortWeekday={(locale, date) =>
                date.toLocaleDateString(locale, { weekday: "short" }).slice(0, 2)
              }
              /* 🎨 COLORS */
              tileClassName={({ date, view }) => {
                if (view !== "month") return null;
                if (isFutureDate(date)) return "future";
                const status = getCalendarStatus(date);
                let className = "";
                if (status) {
                  className = status.is_completed ? "completed" : "missed";
                }
                if (selectedDate && isSameDay(date, selectedDate)) {
                  className += " selected";
                }
                return className.trim();
              }}
              tileDisabled={({ date, view }) => {
                if (view !== "month") return false;
                return isFutureDate(date);
              }}
            />
          </MonthlyCalendar>
        </CalendarPicker>
      </CalendarWrapper>
    );}
  



  return (
    <div style={{ maxWidth: "1246px", padding: "24px 0px 40px 0px", margin: "auto", width: "100%" }}>

      {isLoading ?
      
        (<SkeletonLoder width={"100%"} height={"700px"} style={{marginTop:"25px"}}/>)
     
        :
        (<>
          <ChallengesContainer>
            <div className='right-row'>
              <div className="icon"
                onClick={() => {
                  if (isCompletedTab) {
                    history.push({
                      pathname: "/challenges/completed",
                      state: { activeSubTab: "monthly" }
                    });
                  } else {
                    history.push("/portal");
                  }
                }}>
                {BackArrowFeed("#DA6C74")}
              </div>
              <TabViewNew
                width
                padding
                margin={"0px"}
                height="40px"
                active={activeTab == "Challenge" ? 1 : 0}
                onClick={() => setActiveTab("Challenge")}
              >
                {"Challenge"}
              </TabViewNew>
            </div>
            {isCompletedTab ?null : <div className="exit-challenge">
              <HoverButton
                title="Exit Challenge"
                width="20px"
                height="20px"
                svgPath={<ExitChallenge />}
                onClick={() => exitChallenge()}
                backgroundColor="white"
                backgroundColorActive="#DA6C74"
              />
            </div>}
          </ChallengesContainer>
          <ChallengeHeading>
            {challengeDetails?.title}
          </ChallengeHeading>
    
          <ChallengeDetailsConatainer>
            <div className="insideConatainer">
              {renderLeftContainer()}
              {renderRightContainer()}
    
             
            </div>
          </ChallengeDetailsConatainer>
    
          {exitChallengePopup && (<CommonModalNew
            show={exitChallengePopup}
            icon={RecognitionWarningIcon("#CE7841")}
            title="Exit Challenge"
            description="Are you sure you want to exit this challenge?"
            descriptionColor="#CE7841"
            subDescription="This will reset your progress and remove all your challenge activity. This action cannot be undone."
            onCancel={hideExitChallenge}
            onConfirm={() =>joinChallenge()}
            cancelText="Stay in Challenge"
            confirmButtonText="Exit Challenge"
            buttonIcon={ExitChallenge("white")}
            confirmButtonWidth="198px"
            cancelButtonWidth="155px"
            modalHeight="265px"
            isFontSize="16px"
            confirmDisabled={isExiting} 
          />)}
          
        </>
        )}
    </div>
  );
}

MonthlyChallengeDetailsPage.propTypes = {
  history: PropTypes.object.isRequired,
};

export default MonthlyChallengeDetailsPage;
